import { type EntitiesHome } from '../../../states/entities/home';
import { type StateType } from '../../../states/index';
import { type Selector } from '../../../types/selectors';
import { selectEntitiesState } from '../entitiesPrimary.selector';

export const selectEntitiesHomeState: Selector<EntitiesHome | undefined> = (state: StateType) =>
  selectEntitiesState(state).home;

//#region state.entities.home
export const selectEntitiesHomeMatches: Selector<Array<number> | undefined> = (state: StateType) =>
  selectEntitiesHomeState(state)?.matches;
//#endregion
